'use es6';

import styled from 'styled-components';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import { INPUT_STYLES } from './constants';
const RadioInput = styled(UIRadioInput).withConfig({
  displayName: "RadioInput",
  componentId: "sc-1a1rq65-0"
})(["", ""], INPUT_STYLES);
export default RadioInput;